// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__1wRkE","content":"LayoutSettings_content__2T8rW"};